import React, { useState } from 'react';
import { Form } from 'react-final-form';
import { useParams } from 'react-router';

import validate from '../../../../utils/validate';
import { predictMessageYopValidation } from './validation';
import PredictFormInner from './PredictFormInner';

function PredictForm({ onPredictResponse }) {
  const { id } = useParams();
  const [previousRequest, setPreviousRequest] = useState({});

  const predictFormInitialValues = {
    url: '',
    message: '',
  };

  const handlePredictMessage = (values) => {
    const newRequest = {
      message: values.message,
      url: values.url,
    };

    setPreviousRequest(newRequest);

    onPredictResponse({ projectId: id, ...newRequest });
  };

  return (
    <Form
      initialValues={predictFormInitialValues}
      onSubmit={handlePredictMessage}
      subscription={{ submitting: true, pristine: true }}
      validateOnBlur={false}
      validate={(values) => validate(values, predictMessageYopValidation())}
      render={({ handleSubmit }) => <PredictFormInner onSubmit={handleSubmit} previousRequest={previousRequest} />}
    />
  );
}

export default PredictForm;
